import type { ReactNode } from 'react';
import { Breadcrumb, type Crumb } from '../molecules';

interface PageTemplateProps {
  title: string;
  breadcrumb?: Crumb[];
  /** Shown next to the title, e.g. the client's status. */
  badge?: ReactNode;
  /** One line under the title. */
  meta?: ReactNode;
  /** Right of the title, e.g. the time range that scopes the page. */
  actions?: ReactNode;
  /** The page's headline numbers, shown on the band under the title. */
  hero?: ReactNode;
  children: ReactNode;
}

const CONTAINER = 'mx-auto w-full max-w-[1360px] px-4 sm:px-8';

/** The band continues from the top bar with the title and headline numbers; content panels overlap its lower edge. */
export function PageTemplate({ title, breadcrumb, badge, meta, actions, hero, children }: PageTemplateProps) {
  return (
    <>
      <div className="bg-band text-band-fg">
        <div className={`${CONTAINER} flex flex-col gap-8 pb-24 pt-7`}>
          <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-4">
            <div className="flex min-w-0 flex-col gap-2">
              {breadcrumb && <Breadcrumb items={breadcrumb} />}
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <h1 className="text-band-fg">{title}</h1>
                {badge}
              </div>
              {meta && <p className="text-[15px] text-band-fg-secondary">{meta}</p>}
            </div>
            {actions}
          </div>
          {hero}
        </div>
      </div>
      <div className={`${CONTAINER} -mt-16 flex flex-col gap-8 pb-16`}>{children}</div>
    </>
  );
}
